export { GalaxySideDrawerModule } from './src/side-drawer.module';
export { DynamicOpenCloseTemplateRefService } from './src/dynamic-open-close-template-ref.service';
export {
  ClosingSideDrawerComponent,
  SideDrawerContentDirective,
  SideDrawerFooterDirective,
  SideDrawerTitleActionsDirective,
} from './src/closing-side-drawer/closing-side-drawer.component';
export { SideDrawerContainerComponent } from './src/side-drawer-container/side-drawer-container.component';
